module.exports = __webpack_public_path__ + "img/competition.0d074014.png";